var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6466 6.98024L13.2127 9.10626L17.7328 13.0546H0V16.0918H17.7328L13.2127 20.0401L15.6466 22.1661L24.3392 14.5732L15.6466 6.98024ZM31.2932 25.2033H17.3851V28.2405H31.2932C33.2056 28.2405 34.7703 26.8738 34.7703 25.2033V3.94306C34.7703 2.27261 33.2056 0.905884 31.2932 0.905884H17.3851V3.94306H31.2932V25.2033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.873921c196937672703dd0663b135dab.svg";
export { ForwardRef as ReactComponent };